import React, { useEffect, useState } from 'react'

import { StyleSheet, Platform, Keyboard } from 'react-native'
import { KeyboardAwareScrollView } from '../Components'

import delay from 'delay'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
  Label,
  Description,
  Space,
  TextInputExtended,
  Select,
  Button,
  ReturnFooter,
  ErrorMessage
} from '@sart/components'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, typography, colors } from '@sart/styles'
import client, { useData, useClient } from '@sart/client'
import { useContent } from '@sart/content'
import * as theme from '../Sign/signTheme'

import account from './account'

export default function ProfileIdentification(props) {
  const { navigation } = props

  const [loading, setLoading] = useState(true)
  const [error, setError] = useData(false)
  const [updateProduct, setUpdateProduct] = useState({})

  useEffect(() => void fetchUpdateProduct(),[])

  

  async function fetchUpdateProduct() {
    setLoading(true)

    try {
      var updateProducts = await client.callApi('catalog','getUpdatePersonalDetails',[client.cache.catalogId])
      setUpdateProduct(updateProducts[0])
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
}

  const content = useContent()

  const {
    cache: {
      customer,
    } = {}
  } = useClient()

  const personalDetails = customer ? customer.personalDetails : undefined
  const formik = useFormik({
    initialValues: {
      firstName: personalDetails ? (customer.personalDetails.firstName || '') : '',
      middleName: personalDetails ? (customer.personalDetails.middleName || '') : '',
      lastName: personalDetails ? (customer.personalDetails.lastName || '') : '',
      vat: personalDetails ? (customer.personalDetails.taxCode || '') : '',
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string().trim().required(content.forms.required).test('first-name-check', content.profile_identification.noSpecialCharacters, value => validateName(value)),
      middleName: Yup.string().trim().test('middle-name-check', content.profile_identification.noSpecialCharacters, value => validateName(value)),
      lastName: Yup.string().trim().required(content.forms.required).test('last-name-check', content.profile_identification.noSpecialCharacters, value => validateName(value)),
      vat: Yup.string().trim().test('vat-check', content.profile_identification.rfcValid, value => validateRFC(value)
      )
    }),
    onSubmit: handleSubmit
  })

  function validateName(value) {
    if(value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-]+$/)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  function validateRFC(value) {
    if(value) {
      if (value.match(/^[A-Za-z0-9]{12,13}$/)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  function detailsHaveChanged(values){
    return customer.personalDetails.firstName !== values.firstName ||
           customer.personalDetails.middleName !== values.middleName ||
           customer.personalDetails.lastName !== values.lastName ||
           customer.personalDetails.taxCode !== values.vat
  }

  async function handleSubmit(values, form) {
    Keyboard.dismiss()
    form.setSubmitting(true)
    if (detailsHaveChanged(values)){
      var extendedData = {}
      extendedData.serviceLegacyId = client.cache.serviceLegacyId
      if (customer.personalDetails.firstName !== values.firstName){
        customer.personalDetails.firstName = values.firstName
        extendedData.firstName = values.firstName
      }

      if (customer.personalDetails.middleName !== values.middleName){
        customer.personalDetails.middleName = values.middleName
        extendedData.middleName = values.middleName
      }
      if (customer.personalDetails.lastName !== values.lastName){
        customer.personalDetails.lastName = values.lastName
        extendedData.lastName = values.lastName
      }

      if(customer.personalDetails.taxCode !== values.vat) {
        extendedData.taxCode = values.vat
      }
      try {
        
         // Originally newCode variable. Changed it. Not sure if this is the solution.
          
          var order = await client.checkoutCustomerProductNoPayment(updateProduct,extendedData)
          if (order.status === "failed"){
            //order failed, throw an exception to be caught
            throw new Error(content.menu.orderFailed)
          
        }
  
        let updatedCustomer = await client.callApi('customer','getCustomer',[customer.customerId])
        console.log('updated customer is: ')
        console.log(JSON.stringify(updatedCustomer,null,2))
        client.setCache({customer: updatedCustomer})
        navigation.navigate('Account')

      } catch (error) {
      const message = prettyErrorMessage(error, 'profileIdentification', content)
      form.setFieldError('vat', message)
      form.setSubmitting(false)
      }
    } else {
      form.setSubmitting(false)
    }
  }

  var middleNameRef, lastNameRef, vatRef;
  return (
    <KeyboardAwareScrollView style={styles.container}>
      <Description style={styles.description}>{content.profile_identification.description}</Description>

      <Space height={24} />

      <TextInputExtended
        label={content.forms.firstNameLabel}
        value={formik.values.firstName}
        placeholder={content.forms.firstNamePlaceholder}
        {...Platform.select({
          web: { autoComplete: 'given-name' },
          ios: { textContentType: 'givenName' },
          android: { autoCompleteType: 'name' }
        })}
        onChangeText={formik.handleChange('firstName')}
        onBlur={formik.handleBlur('firstName')}
        error={formik.touched.firstName && formik.errors.firstName}
        style={styles.inputText}
        returnKeyType="next"
        onSubmitEditing={() => this.middleNameRef.focus()}
        selectionColor={colors.common}
        labelStyle={styles.label}
        {...theme.textInputWhiteBackground}
        {...testID('firstName')}
      />

      <Space height={8} />

      <TextInputExtended
        label={content.forms.middleNameLabel}
        value={formik.values.middleName}
        placeholder={content.forms.middleNamePlaceholder}
        {...Platform.select({
          web: { autoComplete: 'additional-name' },
          ios: { textContentType: 'middleName' },
          android: { autoCompleteType: 'name' }
        })}
        onChangeText={formik.handleChange('middleName')}
        onBlur={formik.handleBlur('middleName')}
        error={formik.touched.middleName && formik.errors.middleName}
        style={styles.inputText}
        /*ref={ref => {
          this.middleNameRef = ref;
        }} */
        returnKeyType="next"
        onSubmitEditing={() => this.lastNameRef.focus()}
        selectionColor={colors.common}
        labelStyle={styles.label}
        {...theme.textInputWhiteBackground}
        {...testID('middleName')}
      />

      <Space height={8} />

      <TextInputExtended
        label={content.forms.lastNameOptionTwo}
        value={formik.values.lastName}
        placeholder={content.forms.lastNameOptionTwoPlaceholder}
        {...Platform.select({
          web: { autoComplete: 'family-name' },
          ios: { textContentType: 'familyName' },
          android: { autoCompleteType: 'name' }
        })}
        onChangeText={formik.handleChange('lastName')}
        onBlur={formik.handleBlur('lastName')}
        error={formik.touched.lastName && formik.errors.lastName}
        style={styles.inputText}
        // {...theme.textInput}
        /*ref={ref => {
          this.lastNameRef = ref;
        }} */
        returnKeyType="next"
        onSubmitEditing={() => this.vatRef.focus()}
        selectionColor={colors.common}
        labelStyle={styles.label}
        {...theme.textInputWhiteBackground}
        {...testID('lastName')}
      />

      <Space height={24} />
      {error && [
        <ErrorMessage key={0}>{error.message}</ErrorMessage>,
        <Space height={8} key={1}/>
      ]}
      <Button
        title={content.common.save}
        disabled={!formik.dirty || !formik.isValid || formik.isSubmitting || loading}
        onPress={formik.handleSubmit}
        titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
        disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45}}        
        style={styles.enabledStyle}
        disabledStyle={styles.disabledStyle}
        {...testID('identificationSubmit')}
      />

      <Space height={24} />
    </KeyboardAwareScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
    backgroundColor: colors.white
  },
  enabledStyle: {
    backgroundColor: colors.srDarkGreen
  },
  disabledStyle: {
    backgroundColor: colors.srDarkGreen + 60,
    borderColor: colors.srGreen,
    borderWidth: 1
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.srGreen
  },
  inputText: {
    ...typography.demi,
    borderColor: colors.srGreen
 },
  titleStyle: {
    ...typography.extrabold, 
    fontSize: 18
  },
  label: {
    color: colors.srGreen
  }
})
